import React from "react";
import "./App.css";
import MessageSystem from './MessageSystem';
import DisplayAbout from './DisplayAbout';

function App() {
return (
    <MessageSystem />
);
}

export default App;
